import React from 'react'

const HeaderDownText = () =>
{
    return (
        <div className="header_down--text">
            <span className="gray"> CREATE A</span> <span className="italic_bold">
                POWERFUL</span> <span className="gray"> SOLUTION NOW!</span>
        </div>
    )
}

export default HeaderDownText
